/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./VAccordion.css";

import * as React from "react";

import { VAccordionProps, VAccorionState } from "./VAccordion.types";

export default class VAccordion extends React.Component<VAccordionProps, VAccorionState> {

   private componentClassName: string;
   private header: React.ReactNode;

   constructor(props: VAccordionProps) {

      super(props);

      this.componentClassName = "tk-vaccordion" + (this.props.componentName ? `-${this.props.componentName}` : "");

      this.state = {
         expanded: true
      }

   }

   public render() {

      this.header =

         <div className="tk_vaccordion-header" onMouseDown={this.expandCollapseMouseDown}>

            <div className="tk_vaccordion-header-handle-container">
            </div>

            {this.props.header}

         </div>


      return (

         <div className={this.componentClassName} data-expanded={this.state.expanded}>
            {this.header}
            <div className="tk_vaccordion-container">
            {this.props.children}
            </div>
         </div>

      )

   }

   private expandCollapseMouseDown = (e: React.MouseEvent) => {
      this.setState({ expanded: !this.state.expanded });
      e.preventDefault();
   }

}